module.exports = __webpack_public_path__ + "img/huizhang.7fc907cb.png";